import { Component } from 'react';
import ReactModal from '../../../../../../components/Modal';
import AddKeywordModal from '../../../../promptGenerator/components/addKeywordModal';
import { withTranslation } from 'react-i18next';
import PromptsView from '../../../../promptGenerator/components/PromptsView';

class PromptsModal extends Component {
    constructor(props) {
        super(props);

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.onSelectPrompts = this.onSelectPrompts.bind(this);
        this.openAddKeywordModal = this.openAddKeywordModal.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.onSelectAllPrompts = this.onSelectAllPrompts.bind(this);

        this.state = {
            isOpen: false,
            selectedItems: ['l-0', 'r-0'],
            selectedCollapse: null,
            isAddKeywordModalOpen: false,
            selectedPrompts: [],
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.unique_url_slug.toLowerCase().includes(search.toLowerCase());
        });
    }

    onOpen() {
        this.setState({
            isOpen: true,
        });
    }

    onClose() {
        this.setState({
            isOpen: false,
        });
    }

    showOpened(name, value) {
        return this.state.selectedItems.includes(name) ? value ?? 'active' : '';
    }

    onClickOnStep(id) {
        this.setState({
            selectedItems: this.state.selectedItems.includes(id)
                ? this.state.selectedItems.filter((item) => item !== id)
                : [...this.state.selectedItems, id],
        });
    }

    onSelectPrompts(prompt) {
        this.setState({
            selectedPrompts: this.state.selectedPrompts.includes(prompt)
                ? this.state.selectedPrompts.filter((item) => item !== prompt)
                : [...this.state.selectedPrompts, prompt],
        });
    }

    openAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: true });
    }

    closeAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: false });
    }

    onSelectAllPrompts(prompts) {
        const allSelected = prompts.every((prompt) => this.state.selectedPrompts.includes(prompt));
        this.setState({
            selectedPrompts: allSelected
                ? this.state.selectedPrompts.filter((item) => !prompts.includes(item))
                : [...new Set([...this.state.selectedPrompts, ...prompts])],
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <button className="table-action-main-btn" onClick={this.onOpen}>
                    {t('ai_tracking.prompt_history.modal.button', 'Prompts')}
                </button>
                {this.state.isOpen && (
                    <ReactModal modalState={this.state.isOpen} className="width-md">
                        <div className="prompt-history-modal">
                            {this.props.items?.topics?.length > 0 ? (
                                <>
                                    <div className="my-20">
                                        <div
                                            className={`prompt-generator-body-box ${
                                                this.props.additionalClass || ''
                                            }`}
                                        >
                                            <div className="prompt-generator-body-box-content">
                                                {this.props.items?.topics
                                                    .filter((_, i) => i % 2 === 0)
                                                    ?.map((item, i) => (
                                                        <PromptsView
                                                            item={item}
                                                            showOpened={this.showOpened}
                                                            onClickOnStep={this.onClickOnStep}
                                                            headerKey={'name'}
                                                            selectedItems={
                                                                this.state.selectedPrompts
                                                            }
                                                            onSelectPrompts={this.onSelectPrompts}
                                                            uniqueKey={`l-${i}`}
                                                            key={i}
                                                            onSelectAllPrompts={
                                                                this.onSelectAllPrompts
                                                            }
                                                        />
                                                    ))}
                                            </div>
                                            <div className="prompt-generator-body-box-content">
                                                {this.props.items?.topics
                                                    .filter((_, i) => i % 2 === 1)
                                                    ?.map((item, i) => (
                                                        <PromptsView
                                                            item={item}
                                                            showOpened={this.showOpened}
                                                            onClickOnStep={this.onClickOnStep}
                                                            headerKey={'name'}
                                                            selectedItems={
                                                                this.state.selectedPrompts
                                                            }
                                                            onSelectPrompts={this.onSelectPrompts}
                                                            uniqueKey={`r-${i}`}
                                                            key={i}
                                                            onSelectAllPrompts={
                                                                this.onSelectAllPrompts
                                                            }
                                                        />
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                t('global.no_data')
                            )}
                        </div>
                        <div className="btn-wrapper">
                            <button
                                className="button button-filled button-primary width-sm btn align-items-center justify-content-center"
                                onClick={this.openAddKeywordModal}
                                disabled={this.state.selectedPrompts.length === 0}
                            >
                                {t('ai_tracking.prompt_history.track_selected_prompts')}
                            </button>
                            <button
                                type="button"
                                className="button button-outline button-primary width-sm btn"
                                onClick={this.onClose}
                                style={{ lineHeight: 'unset' }}
                            >
                                {t('global.close')}
                            </button>
                        </div>
                    </ReactModal>
                )}
                {this.state.isAddKeywordModalOpen && (
                    <AddKeywordModal
                        isOpen={this.state.isAddKeywordModalOpen}
                        onClose={this.closeAddKeywordModal}
                        prompts={this.state.selectedPrompts}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(PromptsModal);
